import { Column, CreateDateColumn, Entity,UpdateDateColumn, PrimaryGeneratedColumn, VersionColumn } from "typeorm";


@Entity('rm_tolerance')
export class RmTolerance {

    @PrimaryGeneratedColumn("increment",{name:'rm_tolerance_id'})
    rmToleranceId:number;

    @Column("date",{
        nullable:false,
        name:"date"
    })
   date:Date;

    @Column("decimal",{
        nullable:false,
        precision: 5,
        scale: 2,
        name:"loose_shell"
    })
    looseShell:number;

    @Column("decimal",{
        nullable:false,
        
        name:"soft_shell",
        precision: 5,
        scale: 2,
    })
    softShell:number;

    @Column("decimal",{
        nullable:false,
        precision: 5,
        scale: 2,
        name:"fungus"
    })
    fungus:number;

    @Column("boolean",{
        nullable:false,
        default:true,
        name:"is_active"
    })
    isActive:boolean;

    @CreateDateColumn({
        name: "created_at",
        type: "datetime"
    })
    updateAt: Date;

    @Column("varchar", {
        nullable: false,
        default:1,
        name: "created_user"
    })
    createdUser: string | null;
  
  
    @UpdateDateColumn({
        name: "updated_at",
        type:'datetime'
    })
    updatedAt: Date;

    @Column("varchar",{
        nullable : true,
        name: "updated_user"
    })
    updatedUser: string | null;

    @VersionColumn({
        default:1,
        name: "version_flag"
    })
    versionFlag: number;
  createdAt: Date;
}